import './App.scss';

import Header from './components/_shared/Header';
import FirstSection from './components/Sections/FirstSection';
import useNavigationStore from './stores/navigationStore';
import BeforeStart from './components/Sections/BeforeStart';
import SecondSection from './components/Sections/SecondSection';
import ThirdSection from './components/Sections/ThirdSection';
import FourthSection from './components/Sections/FourthSection';
import FifthSection from './components/Sections/FifthSection';
import SixthSection from './components/Sections/SixthSection';
import SeventhSection from './components/Sections/SeventhSection';
import { useEffect } from 'react';
import useRegistrationStore from './stores/registrationStore';
import useAuthStore from './stores/authStore';
import LoginModal from './components/_shared/LoginModal.tsx';
import { Toaster } from 'react-hot-toast';
import { usePsiUploadsDocuments } from './hooks/usePsiUploadsDocuments';
import Loader from './components/_shared/UI/Loader';
import Container from './components/_shared/Container';

const sectionMap = {
    0: BeforeStart,
    1: FirstSection,
    2: SecondSection,
    3: ThirdSection,
    4: FourthSection,
    5: FifthSection,
    6: SixthSection,
    7: SeventhSection
};

export default function App() {
    const { section } = useNavigationStore();
    // affichage du store le temps du developpement
    const { registration, setField } = useRegistrationStore();
    if (window.location.origin === "http://localhost:3000") {
        console.log(registration);
    }
    const { isLoginModalOpen, closeLoginModal } = useAuthStore();
    const { navigateToDemand, isLoading } = usePsiUploadsDocuments();

    useEffect(() => {
        // suppression du bandeau marketing
        const notifBanner = document.getElementById("top-notif-banner");
        if (notifBanner) {
            notifBanner.style.display = "none";
        }

        // suppression du menu circulaire
        const circularMenu = document.getElementById("circular-menu-1");
        if (circularMenu) {
            circularMenu.style.display = "none";
        }

        const { brandcode, brandname, brandslug, sitecode }: any = document.getElementById("legal-entity-account-opening")?.dataset;

        const searchParams = new URLSearchParams(window.location.search);
        const queryCgpId = searchParams.get("company");
        if (brandname && brandcode && brandslug && brandcode !== 'BDI') {
            setField('partner_informations', {...registration.partner_informations, is_partner: true, brand: {name: brandname, code: brandcode, slug: brandslug, sitecode: sitecode}})
        }
        if (queryCgpId) {
            setField('partner_informations', {...registration.partner_informations, cgp_id: queryCgpId})
        }

        const hasOriginParams = ['bd_campaign', 'bd_annonce', 'bd_format', 'bd_source', 'bd_term'].some((key) => searchParams.has(key));
        if (hasOriginParams) {
            const referer = window.location.search.slice(1).replace(/=/g, '%3D').replace(/&/g, '%26');
            setField('origin', {
                tracking: searchParams.get('bd_campaign') || '',
                annonce: searchParams.get('bd_annonce') || '',
                format: searchParams.get('bd_format') || '',
                support: searchParams.get('bd_source') || '',
                term: searchParams.get('bd_term') || '',
                referer
            })
        }

        const queryDemandID = searchParams.get("demandId");
        const queryPersonId = searchParams.get("prospectId");
        if (queryDemandID && queryPersonId) {
            navigateToDemand(queryDemandID, queryPersonId);
        }
    }, [])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [section.block]);

    const SelectedSection = sectionMap[section.number as keyof typeof sectionMap] || null;

    if (isLoading) {
        return (
            <div className="container">
                <Container>
                    <div style={{marginTop: '280px'}}>
                        <Loader type="SPINNER" />
                    </div>
                </Container>
            </div>
        )
    }
    return (
        <div className="container">
            <Header />
            {isLoginModalOpen && <LoginModal onClose={closeLoginModal} />}
            {SelectedSection ? <SelectedSection /> : null}
            <Toaster />
        </div>
    );
}